import Grid from "@mui/material/Grid2";
import Stack from "@mui/material/Stack";
import { useWatch } from "react-hook-form";
import MonitoringReportDirectionOptionsDropdown from "../../../../Utilities/Constants/MonitoringReportDirectionOptionsDropdown";
import MonitoringReportStartEndOptionsDropdown from "../../../../Utilities/Constants/MonitoringReportStartEndOptionsDropdown";
import ValidatedCheckBoxElement from "../../../../Utilities/Forms/ValidatedCheckBoxElement";
import ValidatedSelectElement from "../../../../Utilities/Forms/ValidatedSelectElement";
import DropDownViewModel from "../../../../Utilities/ViewModels/DropDownViewModel";

interface IProps {
    index: number
    baseName: string
    formContext: any
    surveyTimesDropdown: DropDownViewModel[]
    surveyEndTimesDropdown: DropDownViewModel[]

}

export default function UserDefinedModeSplit({ index, baseName, formContext, surveyTimesDropdown, surveyEndTimesDropdown }: IProps) {

    const enabled = useWatch({
        control: formContext.control,
        name: `${baseName}.enabled`
    });

    const showTimeSelection = useWatch({
        control: formContext.control,
        name: `${baseName}.startEnd`
    });

    return (
        <Grid container size={12}>
            <Grid size={12}>
                <Stack spacing={1}>
                    <ValidatedCheckBoxElement name={`${baseName}.enabled`} label={`User Defined Mode Split ${index}`} />
                    {enabled === true && (
                        <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
                            <ValidatedSelectElement name={`${baseName}.startEnd`} label="Start/End Time" options={MonitoringReportStartEndOptionsDropdown} hideClearIcon={true} />
                            {showTimeSelection == "0" &&
                                <>
                                    <ValidatedSelectElement name={`${baseName}.start`} label="Start" options={surveyTimesDropdown} hideClearIcon={true} />
                                    <ValidatedSelectElement name={`${baseName}.end`} label="End" options={surveyEndTimesDropdown} hideClearIcon={true} />
                                </>
                            }
                            <ValidatedSelectElement name={`${baseName}.direction`} label="Direction" options={MonitoringReportDirectionOptionsDropdown} hideClearIcon={true} />
                        </Stack>
                    )}
                </Stack>
            </Grid>
        </Grid>
    );
}
